import { Component, ComponentClass } from 'react'
import { logError, logWarn } from 'utils/logger'
import { PageLoadError } from 'view/PageLoadError'

window.addEventListener('error', (e) => {
  if (e.error instanceof SyntaxError) {
    // SyntaxError indicates that old chunk doesn't exist anymore after release.
    // Suppress SyntaxError as we're going to handle this issue inside AsyncComponent.
    e.preventDefault()
  }
})

interface AsyncComponentState {
  Component: ComponentClass
  isError: boolean
}

export const asyncComponent = (getComponent) => {
  return class AsyncComponent extends Component<{}, AsyncComponentState> {
    static Component = null // it's in static to keep for the next navigations

    constructor(props) {
      super(props)
      this.state = {
        // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'ComponentCl... Remove this comment to see the full error message
        Component: AsyncComponent.Component,
        isError: false,
      }
    }

    componentDidMount() {
      if (!this.state.Component) {
        this.load()
      }
    }

    load = async () => {
      try {
        const { default: Component } = await getComponent()
        AsyncComponent.Component = Component
        this.setState({
          Component,
          isError: false,
        })
      } catch (e) {
        // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
        if (/\.js$/.test(e.request)) {
          // Old chunk doesn't exist anymore after release, we should reload page to get new one.
          logWarn('Force reload of the page to get new chunk')
          window.location.reload()

          return
        }

        // @ts-expect-error TS(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        logError(e)
        this.setState({ isError: true })
      }
    }

    render() {
      const { Component, isError } = this.state

      if (isError) {
        return <PageLoadError />
      }

      if (!Component) {
        return null
      }

      return <Component {...this.props} />
    }
  }
}
